module.exports = __webpack_public_path__ + "static/media/bg.8a59461c.png";